import React from 'react';

import { Currencies } from 'src/enums';

import {
  OtherCategoryInterface,
  VehicleCategoryInterface,
} from './BookingSummary.interface';

import { BookingSummaryCategorySection } from './BookingSummaryCategorySection';
import * as S from './BookingSummaryCategory.style';
import { B2CRentalUnitOfMeasure } from '../Enums';

type GenericCategoryProps = (
  | OtherCategoryInterface
  | VehicleCategoryInterface
) & { showQuantity?: boolean };

export const BookingSummaryCategory = ({
  title,
  onDiscountInfoClick,
  showDetailedPrice,
  currency,
  showQuantity,
  ...bookingSummaryCategoryProps
}: GenericCategoryProps & {
  title: string;
  currency: Currencies;
  onDiscountInfoClick?: () => any;
  showDetailedPrice?: boolean;
}) => {
  const productPrices = bookingSummaryCategoryProps?.productPrices || [];
  const fees = bookingSummaryCategoryProps?.fees || [];

  if (
    !bookingSummaryCategoryProps?.productPrice &&
    !(productPrices?.length > 0) &&
    !(fees?.length > 0)
  ) {
    return <></>;
  }

  return (
    <S.BookingSummaryCategoryContainer>
      <S.BookingSummaryCategoryTitle>
        {title?.toUpperCase()}
      </S.BookingSummaryCategoryTitle>
      {bookingSummaryCategoryProps?.productPrice && (
        <BookingSummaryCategorySection
          currency={currency}
          showDetailedPrice={
            showDetailedPrice &&
            !!bookingSummaryCategoryProps?.productPrice?.duration &&
            !!bookingSummaryCategoryProps?.productPrice?.averagePrice &&
            [B2CRentalUnitOfMeasure.DAY, B2CRentalUnitOfMeasure.NIGHT].includes(
              bookingSummaryCategoryProps?.productPrice?.duration?.unit,
            ) &&
            !bookingSummaryCategoryProps?.productPrice?.prepaid &&
            !bookingSummaryCategoryProps?.productPrice?.included
          }
          showQuantity={showQuantity}
          onDiscountInfoClick={onDiscountInfoClick}
          {...bookingSummaryCategoryProps?.productPrice}
        />
      )}
      {productPrices.map((productPrice, index) => (
        <BookingSummaryCategorySection
          currency={currency}
          key={`${title}-productPrices-${index}`}
          onDiscountInfoClick={onDiscountInfoClick}
          showDetailedPrice={
            showDetailedPrice &&
            !!productPrice?.duration &&
            !!productPrice?.averagePrice &&
            [B2CRentalUnitOfMeasure.DAY, B2CRentalUnitOfMeasure.NIGHT].includes(
              productPrice?.duration?.unit,
            ) &&
            !productPrice?.prepaid &&
            !productPrice?.included
          }
          showQuantity={showQuantity}
          {...productPrice}
        />
      ))}
      {fees.map((fee, index) => (
        <BookingSummaryCategorySection
          currency={currency}
          key={`${title}-fees-${index}`}
          onDiscountInfoClick={onDiscountInfoClick}
          showDetailedPrice={false}
          {...fee}
        />
      ))}
    </S.BookingSummaryCategoryContainer>
  );
};
